export const requiredField = {
  package_case: ["required"],
  percentage: ["required"],
  count: ["required"],
  lead_classification: ["required"],
};

export const numericFieldValue = (value) =>
  value === 0 || value === "0" ? value : value || "";

/**
 * @param {object} data
 * @param {{ allowZero?: boolean }} [options] allowZero for classification-only rows (0% / 0 count)
 */
export const validateAttrition = (data, options = {}) => {
  const errors = {};
  const minValue = options.allowZero ? 0 : 1;

  if (!data.package_case?.trim()) {
    errors.package_case = "Package case is required.";
  } else if (data.package_case.length > 50) {
    errors.package_case = "Package case cannot exceed 50 characters.";
  }

  if (
    data.percentage === "" ||
    data.percentage === null ||
    data.percentage === undefined
  ) {
    errors.percentage = "Percentage is required.";
  } else if (isNaN(data.percentage)) {
    errors.percentage = "Percentage must be a valid number.";
  } else if (
    Number(data.percentage) < minValue ||
    Number(data.percentage) > 100
  ) {
    errors.percentage =
      minValue === 0
        ? "Percentage must be between 0 and 100."
        : "Percentage must be between 1 and 100.";
  }

  if (data.count === "" || data.count === null || data.count === undefined) {
    errors.count = "Count is required.";
  } else if (
    !Number.isInteger(Number(data.count)) ||
    Number(data.count) < minValue
  ) {
    errors.count =
      minValue === 0
        ? "Count must be an integer of 0 or more."
        : "Count must be a positive integer (minimum 1).";
  }

  return errors;
};

export const mapLeadClassification = (value) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();

  if (normalized === "lead") return "lead";
  if (normalized === "leadless") return "leadless";
  return "unknown";
};

/**
 * Unique BOM package names + lead classification lookup for attrition checks.
 * Skips empty / N/A packages. Dedupes case-insensitively.
 */
export const collectBomPackages = (bomlines) => {
  const packages = [];
  const leadByPackage = {};
  const seen = new Set();

  (bomlines || []).forEach((line) => {
    const pkg = String(line.Package || "").trim();
    if (!pkg || pkg.toUpperCase() === "N/A") {
      return;
    }

    const packageCase = pkg.slice(0, 50);
    const key = packageCase.toLowerCase();
    if (seen.has(key)) {
      return;
    }

    seen.add(key);
    packages.push(packageCase);
    leadByPackage[key] = mapLeadClassification(line["Lead Classification"]);
  });

  return { packages, leadByPackage };
};

/**
 * Build modal rows from API missing-package list.
 */
export const buildMissingAttritionRows = (
  missingPackages,
  leadByPackage = {}
) =>
  (missingPackages || [])
    .map((pkg) => {
      const package_case = String(pkg || "").trim().slice(0, 50);
      if (!package_case || package_case.toUpperCase() === "N/A") {
        return null;
      }

      return {
        package_case,
        percentage: "",
        count: "",
        lead_classification:
          leadByPackage[package_case.toLowerCase()] || "unknown",
      };
    })
    .filter(Boolean);
